import { StandardButton } from "./buttons"
import { ChromePicker } from "react-color"
import { useState } from "react"
import { IconColorPicker } from "@tabler/icons-react"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import hex_is_light from "../api/is_light_color"

export default function ColorPicker({colorValue, setColor}) {
    const [displayColorPicker, setDisplayColorPicker] = useState(false)
    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker)
    }
    const handleClose = () => {
        setDisplayColorPicker(false)
    }
    const handleChange = (color) => {
        setColor(color.hex)
    }

    return (
        <div style={{ position: 'relative' }}>
            <button onClick={handleClick} className="button-comp small-button small-rounded" style={{ padding: "0.5rem", border: "1px solid var(--grey-200)", marginLeft: "0px", background: colorValue, width: "7rem" }}>
                <HorizontalLayout style={{color: (!hex_is_light(colorValue) ? "white" : "black")}}>
                    <IconColorPicker/>
                    <span style={{marginLeft: "0.5rem"}}>{colorValue.toUpperCase()}</span>
                </HorizontalLayout>
            </button>
            {displayColorPicker ? (
                <div style={{ position: 'absolute', zIndex: 2 }}>
                    <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }} onClick={handleClose}></div>
                    <ChromePicker disableAlpha={true} color={colorValue} onChange={handleChange} />
                </div>
            ) : null}
        </div>
    )
}

export function ColorPickerOutlined({colorValue, setColor}) {
    const [displayColorPicker, setDisplayColorPicker] = useState(false)
    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker)
    }
    const handleClose = () => {
        setDisplayColorPicker(false)
    }
    const handleChange = (color) => {
        setColor(color.hex)
    }

    return (
        <div style={{ position: 'relative' }}>
            <StandardButton onClick={handleClick} style={{ border: `2px solid ${colorValue}`, boxSizing: "border-box", "background": "transparent"}}><HorizontalLayout style={{color: colorValue}}><IconColorPicker/><span style={{marginLeft: "0.5rem"}}>{colorValue}</span></HorizontalLayout></StandardButton>
            {displayColorPicker ? (
                <div style={{ position: 'absolute', zIndex: 2 }}>
                    <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }} onClick={handleClose}></div>
                    <ChromePicker disableAlpha={true} color={colorValue} onChange={handleChange} />
                </div>
            ) : null}
        </div>
    )
}

export function ColorPickerSidePreview({colorValue, setColor}) {
    const [displayColorPicker, setDisplayColorPicker] = useState(false)
    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker)
    }
    const handleClose = () => {
        setDisplayColorPicker(false)
    }
    const handleChange = (color) => {
        setColor(color.hex)
    }

    return (
        <div style={{ position: 'relative' }}>
            <HorizontalLayout style={{"gap": "0.5rem"}}>
                <StandardButton onClick={handleClick} style={{ boxSizing: "border-box" }}><IconColorPicker/></StandardButton>
                <div className="small-rounded center-all standard-border" style={{ width: "8rem", height: "44px", display: "flex", boxSizing: "border-box", background: colorValue, /* border: hex_is_light(colorValue) ? "1px solid #333" : "", */ color: hex_is_light(colorValue) ? "black" : "white"}}>
                    {colorValue}
                </div>
            </HorizontalLayout>
            {displayColorPicker ? (
                <div style={{ position: 'absolute', zIndex: 2 }}>
                    <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }} onClick={handleClose}></div>
                    <ChromePicker disableAlpha={true} color={colorValue} onChange={handleChange} />
                </div>
            ) : null}
        </div>
    )
}